import React from "react";
import { Trans } from "react-i18next";
import ButtonPrimary from "../../../../../shared/components/button-primary/button-primary";
import { useToggleSubscription } from "../../../../../shared/components/toggle-subscription-context/toggle-subscription-context";
import { SUBSCRIPTION_END_DATE } from "../../../../../../config/subscription/subscription.config";
import "./subscribe-section.scss";

const formattedSubscriptionEndDate = SUBSCRIPTION_END_DATE.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

const SubscribeSection = () => {
    const { isOpenSubscription, season } = useToggleSubscription();
    return (
        <section className="home-inscription">
            <div className="home-inscription__wrapper">
                <Trans parent="h2" i18nKey={`home.inscription.${!isOpenSubscription ? "closed" : "text"}`} values={{ season }} />
                {isOpenSubscription && (
                    <div className="home-inscription__cta">
                        <ButtonPrimary tertiary path="/join">
                            Inscription
                        </ButtonPrimary>
                        <p className="home-inscription__deadline">*Date limite de réception des candidatures : {formattedSubscriptionEndDate}</p>
                    </div>
                )}
            </div>
        </section>
    );
};

export default SubscribeSection;
